function removeElementById(id) {
  const targetElement = document.getElementById(id);
  
  if (targetElement) {
    targetElement.remove();
  }
} 

export default removeElementById;
